module.exports = __webpack_public_path__ + "static/media/jednorazowa_opłata_za_dostep_na_rok_pol_roku_miesiac_lub_tydzien.2040bea6.svg";